function createSettingsActions({ apiFetch, syncFromApi }) {
  const fetchSiengeCreditorSyncSettings = () => apiFetch('/api/system-settings/sienge-creditor-sync');
  const fetchSiengeFieldsOptions = () => apiFetch('/api/system-settings/sienge-fields-options');
  const fetchDebugSetting = () => apiFetch('/api/system-settings/debug');
  const fetchDevelopmentResetPreview = () => apiFetch('/api/system-settings/dev-reset-preview');
  const fetchPaymentResetPreview = () => apiFetch('/api/system-settings/dev-reset-payments-preview');

  const updateSiengeCreditorSyncSettings = async (payload) =>
    apiFetch('/api/system-settings/sienge-creditor-sync', {
      method: 'PUT',
      body: JSON.stringify(payload),
    });

  const resetSiengeCreditorSyncSettings = () =>
    apiFetch('/api/system-settings/sienge-creditor-sync', {
      method: 'DELETE',
    });

  const updateSiengeFieldsOptions = async (payload) =>
    apiFetch('/api/system-settings/sienge-fields-options', {
      method: 'PUT',
      body: JSON.stringify(payload),
    });

  const resetSiengeFieldsOptions = () =>
    apiFetch('/api/system-settings/sienge-fields-options', {
      method: 'DELETE',
    });

  const updateDebugSetting = async (debugEnabled) => {
    const data = await apiFetch('/api/system-settings/debug', {
      method: 'PUT',
      body: JSON.stringify({ debug_enabled: debugEnabled === 'S' ? 'S' : 'N' }),
    });
    await syncFromApi(undefined, ['me']);
    return data;
  };

  const updateUser = async (userId, payload) => {
    await apiFetch(`/api/users/${userId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
    await syncFromApi(undefined, ['users', 'me']);
  };

  const createUser = async (payload) => {
    await apiFetch('/api/users', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    await syncFromApi(undefined, ['users']);
  };

  const deactivateUser = async (userId, password) => {
    await apiFetch(`/api/users/${userId}`, {
      method: 'DELETE',
      body: JSON.stringify({ password }),
    });
    await syncFromApi(undefined, ['users', 'me']);
  };

  const resetDevelopmentSystem = (password) =>
    apiFetch('/api/system-settings/dev-reset', {
      method: 'DELETE',
      body: JSON.stringify({ password }),
    });

  const resetPayments = (password) =>
    apiFetch('/api/system-settings/dev-reset-payments', {
      method: 'DELETE',
      body: JSON.stringify({ password }),
    });

  const clearSyncQueue = (password) =>
    apiFetch('/api/system-settings/sync-queue', {
      method: 'DELETE',
      body: JSON.stringify({ password }),
    });

  const fetchCreditorPrefSync = () => apiFetch('/api/system-settings/creditor-preferences-sync');
  const updateCreditorPrefSync = (payload) =>
    apiFetch('/api/system-settings/creditor-preferences-sync', { method: 'PUT', body: JSON.stringify(payload) });

  const fetchLoginLayout = () => apiFetch('/api/system-settings/login-layout', {}, '');

  const updateLoginLayout = (payload) =>
    apiFetch('/api/system-settings/login-layout', {
      method: 'PUT',
      body: JSON.stringify(payload),
    });

  return {
    fetchSiengeCreditorSyncSettings,
    fetchSiengeFieldsOptions,
    fetchDebugSetting,
    fetchDevelopmentResetPreview,
    fetchPaymentResetPreview,
    updateSiengeCreditorSyncSettings,
    resetSiengeCreditorSyncSettings,
    updateSiengeFieldsOptions,
    resetSiengeFieldsOptions,
    updateDebugSetting,
    createUser,
    updateUser,
    deactivateUser,
    resetDevelopmentSystem,
    resetPayments,
    clearSyncQueue,
    fetchCreditorPrefSync,
    updateCreditorPrefSync,
    fetchLoginLayout,
    updateLoginLayout,
  };
}

export { createSettingsActions };
